import {connect} from "react-redux";
import {getAllInvoices, messageReset} from "../store/invoices";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import {FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select} from "@mui/material";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import ReactPaginate from "react-paginate";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Button from "@mui/material/Button";
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import axios from "axios";

function Invoices(props) {
    const navigate = useNavigate()
    const params = useParams()
    const [invoices, setInvoices] = useState([])
    const [filteredInvoices, setFilteredInvoices] = useState(false)
    const [searchWord, setSearchWord] = useState('')
    const [loading, setLoading] = useState(false);
    const [taskId, setTaskId] = useState(null);
    const [status, setStatus] = useState("Загрузка...");

    const [selectedFlight, setSelectedFlight] = useState(
        localStorage.getItem("selectedFlight") || ""
    );

    useEffect(() => {
        localStorage.setItem("selectedFlight", selectedFlight);
    }, [selectedFlight]);

    const handleClick = async () => {
        setLoading(true);
        setStatus("Загрузка...");
        try {
            const response = await axios.get("https://reliablecargo.uz/api/v1/update-invoice/");
            setTaskId(response.data.task_id);
            checkStatus(response.data.task_id);
        } catch (error) {
            setLoading(false);
            setStatus("Произошла ошибка!");
        }
    };

    const checkStatus = async (taskId) => {
        const interval = setInterval(async () => {
            const res = await axios.get(`https://reliablecargo.uz/api/v1/check-invoice-status/${taskId}/`);
            setStatus(res.data.status);
            if (res.data.status === "completed" || res.data.status.startsWith("error")) {
                clearInterval(interval);
                setLoading(false);
            }
        }, 3000); // Har 3 soniyada tekshirish
    };

    useEffect(() => {
        props.getAllInvoices()
    }, [])


    useEffect(() => {
        setInvoices(props.invoices)
    }, [props])


    // Pagination

    let pageItems = filteredInvoices ? filteredInvoices : invoices

    useEffect(() => {
        pageItems = filteredInvoices ? filteredInvoices : invoices
    }, [filteredInvoices])

    const [itemsPerPage, setItemsPerPage] = useState(20)

    const [itemOffset, setItemOffset] = useState(0);

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = pageItems.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(pageItems.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % pageItems.length;
        setItemOffset(newOffset);
    };

    const toEdit = (event, url) => {
        event.preventDefault()
        window.location.href = url
    };

    if (pageCount !== 0 && currentItems.length === 0) {
        let li_lenght = document.querySelectorAll('.pagination ul li').length
        document.querySelectorAll('.pagination ul li')[li_lenght - 2].previousSibling.className = 'selected'
        const data = {"selected": pageCount - 1}
        handlePageClick(data)
    }

    function goBack(e) {
        e.preventDefault()
        navigate('/dashboard/')
    }


    useEffect(() => {
        let filterInvoices = searchWord ? true : false
        if (!searchWord) {
            setFilteredInvoices(false)
        } else if (searchWord) {
            filterInvoices = props.invoices.filter(item => (item.invoice_id.toLowerCase().search(searchWord.toLowerCase()) !== -1))
            const arrayUniqueByKey = [...new Map(filterInvoices.map(item =>
                [item['invoice_id'], item])).values()];
            setFilteredInvoices([...arrayUniqueByKey])
        }
    }, [searchWord, props.invoices]);

    useEffect(() => {
        let filteredData = props.invoices;

        if (searchWord) {
            filteredData = filteredData.filter(item =>
                item.invoice_id.toLowerCase().includes(searchWord.toLowerCase())
            );
        }

        if (selectedFlight) {
            filteredData = filteredData.filter(item => item.flight_number === selectedFlight);
        }

        setFilteredInvoices(filteredData.length ? filteredData : false);
    }, [searchWord, selectedFlight, props.invoices]);

    function ToFilter(e) {
        e.preventDefault()
        if (!e.target.value) {
            setFilteredInvoices(false)
        } else {
            let filterInvoices = false
            if (e.target.value && filterInvoices) {
                const search_word = e.target.value
                filterInvoices = filterInvoices ? props.invoices.filter(item =>
                        (item.invoice_id.toLowerCase().search(search_word.toLowerCase()) !== -1))
                    : props.invoices.filter(item =>
                        (item.invoice_id.toLowerCase().search(search_word.toLowerCase()) !== -1))
                const arrayUniqueByKey = [...new Map(filterInvoices.map(item =>
                    [item['invoice_id'], item])).values()];
                setFilteredInvoices([...arrayUniqueByKey])
            } else if (e.target.value) {
                const search_word = e.target.value
                filterInvoices = props.invoices.filter(item => (item.invoice_id.toLowerCase().search(search_word.toLowerCase()) !== -1))
                const arrayUniqueByKey = [...new Map(filterInvoices.map(item =>
                    [item['invoice_id'], item])).values()];
                setFilteredInvoices([...arrayUniqueByKey])
            }
        }
    }

    return <div>
        <div className={'page worker-page documents'}>
            <Header/>
            <Dashboard/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ArrowBackIcon/>} onClick={(e) => goBack(e)}>
                        Назад
                    </Button>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>{"Инвойсы"}</h2>
                    </div>
                    <div className={'filter-block'}>
                        <form onChange={ToFilter} onSubmit={ToFilter} style={{
                            justifyContent: "space-between",
                            width: "100%", alignItems: "center"
                        }}>
                            <div className={"d-flex align-items-end"}>
                                <p className={"d-flex flex-column"}><span className={"mb-2"}>{"Поиск"}:</span>
                                    <FormControl variant="outlined">
                                        <InputLabel htmlFor="outlined-adornment-password">{"Поиск"}</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            type={'text'}
                                            autoFocus
                                            value={searchWord}
                                            onChange={(e) => setSearchWord(e.target.value)}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle search"
                                                        edge="end"
                                                    >
                                                        <SearchIcon/>
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label={"Поиск"}
                                        />
                                    </FormControl>
                                </p>
                                <p className={"d-flex flex-column"} style={{marginLeft: "20px"}}>
                                    <span className={"mb-2"}>{"Выберите рейс"}:</span>
                                    <FormControl variant="outlined" style={{minWidth: 200}}>
                                        <InputLabel>{"Выберите рейс"}</InputLabel>
                                        <Select
                                            value={selectedFlight}
                                            onChange={(e) => setSelectedFlight(e.target.value)}
                                            label="Выберите рейс"
                                        >
                                            <MenuItem value="">Все рейсы</MenuItem>
                                            {Array.from(new Set(props.invoices.map(item => item.flight_number))).map((flight, index) => (
                                                <MenuItem key={index} value={flight}>{flight}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </p></div>
                            {/* 🆕 FLIGHT_NUMBER SELECT FILTER */}

                            <Button
                                style={{height: "60px"}}
                                className={"flex-end"}
                                onClick={handleClick}
                                endIcon={<BrowserUpdatedIcon/>}
                                loading={loading} disabled={loading}
                                loadingPosition="end"
                                variant="contained">
                                {loading ? status : "Обновить данные"}
                            </Button>
                        </form>
                    </div>
                    {currentItems.length ? <table className="table table-hover table-responsive ">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">{"ID клиента"}</th>
                            <th scope="col">{"Номер партии"}</th>
                            <th scope="col">{"Номер коробки"}</th>
                            <th scope="col">{"Вес"}</th>
                            <th scope="col">{"Загрузить"}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {currentItems.length ? currentItems.map((item, index) => <tr key={index}>
                                <th scope="row">{item.invoice_id}</th>
                                <td>{item.client_id}</td>
                                <td>{item.flight_number}</td>
                                <td>{item.box_number}</td>
                                <td>{item.weight}</td>
                                <td>
                                    <Button variant="contained" title={"Загрузить"} color={"success"}
                                            endIcon={<ArrowDownwardIcon/>}
                                            onClick={(e) => toEdit(e, item.invoice_url)}/>
                                </td>
                            </tr>)
                            :
                            ''
                        }
                        </tbody>
                    </table> : ''}
                    {pageCount > 1 ? <div className={'pagination'}>
                        <ReactPaginate
                            breakLabel="..."
                            nextLabel={<KeyboardArrowRightIcon/>}
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={pageCount}
                            previousLabel={<KeyboardArrowLeftIcon/>}
                            renderOnZeroPageCount={null}
                        />
                    </div> : ''}
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.invoices, {getAllInvoices, getAllVerifyResponse, messageReset})(Invoices)